import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import { removeProduct } from "../../../../store/shop_order/shopOrderSlice"
import { formatPrice } from "../../../../utils/format/formatPrice"
import { getPercentage } from "../../../../utils/get/getPercentage"

// import type { CartProductType, CartProductOptionType } from "../../../types/cart"
import type { RootState } from "../../../../store/store"

const TAX_RATE = 8.1

const Cart = () => {

    const { t } = useTranslation()
    const dispatch = useDispatch()
    const order = useSelector((state: RootState) => state.shopOrder)

    const handleRemove = (uuid) => {
        dispatch(removeProduct(uuid))
    }

    return <>
        {
            order.cart.products.length > 0 ?
                <ul className="flex flex-col gap-2 border border-zinc-200 p-3 rounded-lg divide-y divide-zinc-200 max-h-56 overflow-y-auto">
                    {
                        order.cart.products.map((product) => {
                            return (
                                <li className="flex justify-between items-center gap-4 pt-2" key={product.uuid}>
                                    <div className="flex-1">
                                        <div className="flex justify-between gap-2">
                                            <p className="flex-1 overflow-hidden truncate">
                                                <span className="font-semibold">x{product.qty} </span>
                                                <span className="truncate">{product.name}</span>
                                            </p>
                                            {
                                                product.subtotal > 0 ?
                                                    <p className="flex gap-1">
                                                        <span className="text-zinc-400">CHF </span>
                                                        <span>{formatPrice(product.subtotal)}</span>
                                                    </p> : null
                                            }
                                        </div>

                                        {
                                            product.options.length > 0 ?
                                                <ul className="flex flex-col gap-1">
                                                    {
                                                        product.options.map((option) => {
                                                            return (
                                                                <div className="flex justify-between pl-2 text-sm" key={option.uuid}>
                                                                    <p className="">{option.name}</p>
                                                                    {
                                                                        option.totalPrice != 0 ?
                                                                            <p className="">
                                                                                <span className="text-zinc-400 text-sm">CHF </span>
                                                                                <span>{formatPrice(option.totalPrice)}</span>
                                                                            </p> : null
                                                                    }
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </ul> : null
                                        }
                                    </div>
                                    <button onClick={() => handleRemove(product.uuid)} className="text-xl self-start p-1 rounded-md">
                                        {/* {t("actions.delete")} */}
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5 text-red-500">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                                        </svg>
                                    </button>
                                </li>
                            )
                        })
                    }
                </ul> :
                <div className="flex-1 flex justify-center items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12 text-zinc-200">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859m-19.5.338V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H6.911a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661Z" />
                    </svg>
                </div>
        }

        <div className="flex flex-col gap-2">
            <dl className="bg-zinc-100 rounded-md p-4 flex flex-col gap-2 divide-y divide-white">
                <div className="flex justify-between pt-2">
                    <dt className="text-xl font-semibold">{t("cart.total")}</dt>
                    <dd className="text-xl font-bold">CHF {formatPrice(order.cart.total)}</dd>
                </div>
                <div className="flex justify-between pt-2 text-xs sm:text-sm">
                    <dt className="text-sm">{t("cart.tax")} </dt>
                    <dd className="text-sm">CHF {formatPrice(getPercentage(order.cart.total, TAX_RATE))} -{'>'} {TAX_RATE}% MwsT inkl.</dd>
                </div>
            </dl>
        </div>
    </>
}

export default Cart